import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY'
export const DISPLAY_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm'
export const DISPLAY_DATETIME_SECONDS_FORMAT = 'DD/MM/YYYY HH:mm:ss'

/** Flatpickr: stored value (API / filters) */
export const FLATPICKR_DATE_FORMAT = 'Y-m-d'
export const FLATPICKR_DATETIME_FORMAT = 'Y-m-d H:i'
/** Flatpickr: visible input */
export const FLATPICKR_ALT_DATE_FORMAT = 'd/m/Y'
export const FLATPICKR_ALT_DATETIME_FORMAT = 'd/m/Y H:i'

const PARSE_FORMATS = [
  DISPLAY_DATETIME_SECONDS_FORMAT,
  DISPLAY_DATETIME_FORMAT,
  DISPLAY_DATE_FORMAT,
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD',
]

export function parseAppDate(value) {
  if (value === null || value === undefined || value === '') return null
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null
  if (value instanceof Date) {
    const parsed = dayjs(value)
    return parsed.isValid() ? parsed : null
  }
  const asString = String(value).trim()
  if (!asString) return null
  const strict = dayjs(asString, PARSE_FORMATS, true)
  if (strict.isValid()) return strict
  const loose = dayjs(asString)
  return loose.isValid() ? loose : null
}

export function formatDisplayDate(value) {
  const parsed = parseAppDate(value)
  if (!parsed) {
    return value === null || value === undefined ? '' : String(value)
  }
  return parsed.format(DISPLAY_DATE_FORMAT)
}

export function formatDisplayDateTime(value, { seconds = false } = {}) {
  const parsed = parseAppDate(value)
  if (!parsed) {
    return value === null || value === undefined ? '' : String(value)
  }
  return parsed.format(
    seconds ? DISPLAY_DATETIME_SECONDS_FORMAT : DISPLAY_DATETIME_FORMAT,
  )
}
